import React from 'react';
import './WelcomeSection.css';

const WelcomeSection = () => {
  return (
    <section className="welcome-section">
      <div className="welcome-content">
        <h2 className="welcome-heading">Welcome to Martin Ad Builder</h2>
        <p className="welcome-subtext">
          Your hub for quickly creating TurnKey, iMR-approved creative built just for Cadillac.
          Build brand-compliant, ready-to-use ads, so you can focus on driving results, not chasing approvals.
        </p>
      </div>
    </section>
  );
};

export default WelcomeSection;
